<template>
  <div class="search-page" v-show="isVisibe" :style="topStyle()">
    <div class="search-line">
      <div class="search-left">
        <!-- <img style="width:0.24rem" src="../assets/search/back.png" @click="onCancel" />
        <img style="width:0.48rem" src="../assets/search/scan.png" @click="onScan" /> -->
      </div>
      <div class="search-centent">
        <!-- <img src="../assets/search/search.png" /> -->
        <input type="text" ref="searchField" class="search-centent" v-model="formData.keyword" :placeholder="tipData.keyword" />
      </div>
      <div class="search-text" @click="onSearch">搜索</div>
    </div>
    <div class="search-myline" v-if="(!inputing||!formData.keyword) && ProductCount">
      <div class="myline-left">
        <!-- <img src="@/assets/search/popp.png" /> -->
        <div class="text">
          <div class="txt1">我的常购商品</div>
          <div class="txt2">提升效率一步通</div>
        </div>
        <div class="right">
          <van-icon name="arrow" />
        </div>
      </div>
      <!-- 暂无 -->
      <!-- <div class="myline-right">
        <img src="@/assets/search/babb.png" />
        <div class="text">
          <div class="txt1">限时促销</div>
          <div class="txt2">好物优惠就现在</div>
        </div>
        <div class="right">
          <van-icon name="arrow" />
        </div>
      </div> -->
    </div>

    <div class="tip-content" v-if="inputing&&formData.keyword">
      <li v-for="item in completionData" :key="item.Id" @click="onHistory(item.KeyWord)">{{item.KeyWord}}</li>
    </div>
    <div class="search-history" v-else>
      <div class="history-title">
        <span>历史搜索</span>
        <!-- <van-icon name="delete" @click="clearHistory" /> -->
        <!-- <img src="../assets/search/btnClear.png" style="width:0.32rem" @click="clearHistory" /> -->
      </div>
      <div class="history-content">
        <li v-for="key in historyData.KeyWords" :key="key" @click="onHistory(key)">{{key}}</li>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "SearchControl",
    props: {
      value: {
        type: String,
        default () {
          return "";
        }
      },
      visibe: {
        type: Boolean,
        default () {
          return false;
        }
      },
      needSaftArea: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      visibe(newVal) {
        if (this.isVisibe != newVal) {
          this.isVisibe = newVal;
          if (this.isVisibe) {
            this.inputing = true;
            setTimeout(() => {
              this.$refs.searchField.focus();
            }, 50);
            this.loadHistory();
          }
        }
      },
      value(newVal) {
        if (this.formData.keyword != newVal) {
          this.formData.keyword = newVal;
        }
      }
    },
    created() {
      this.formData.keyword = this.value;
      this.isVisibe = false;
      this.safeArea = this._marginPhoneHeader(false);
    },
    mounted() {},
    data() {
      return {
        safeArea: 0,
        tipData: {
          keyword: "商品名称/功效"
        },
        inputing: false,
        formData: {
          keyword: ""
        },
        historyData: [],
        completionData: [],
        isVisibe: false,
        completioning: false,
        url: {
          creat: "/api_customers/CustomerSearchRecord/Create",
          list: "/api_customers/CustomerSearchRecord/GetCustomerSearchInfo",
          delete: "/api_customers/CustomerSearchRecord/ClearSearchRecord",
          completion: "/api_customers/CustomerSearchRecord/GetTotalSearchInfo"
        },
        ProductCount: null
      };
    },
    methods: {
      topStyle() {
        //console.log(this.needSaftArea);

        if (this.needSaftArea) {
          return { marginTop: this.safeArea + 'px' }
        }
        return {};
      },
      get() {
        this.getAction('api_order/ShoppingCarts/Count').then(res => {
          if (!res.IsSuccess) {
            this.$toast({ position: "bottom", message: res.Msg });
          }
          this.ProductCount = res.Data.ProductCount
        });
      },
      onBlur() {
        setTimeout(() => {
          this.inputing = false;
        }, 300);
      },
      onSearch() {
        if (!this.formData.keyword) {
          this.$toast({ position: "bottom", message: "请输入关键字" });
          return;
        }

        this.isVisibe = false;
        const customerId = this.auth.getCustomerId();
        this.postAction(this.url.creat, {
          CustomerId: customerId,
          ClientType: 0,
          SearchKey: this.formData.keyword
        }).then(res => {
          if (!res.IsSuccess) {
            this.$toast({ position: "bottom", message: res.Msg });
          }
        });

        this.$emit("update:visibe", false);
        this.$emit("input", this.formData.keyword);
        this.$emit("search", this.formData.keyword);
        this.$bus.$emit('updateSearchKeyword', true)
      },
      onCancel() {
        this.isVisibe = false;
        this.$emit("update:visibe", false);
        this.$emit("cancel");
      },
      onScan() {
        this.$emit("scan");
      },
      onHistory(keyword) {
        this.formData.keyword = keyword;
        this.onSearch();
      },
      async loadHistory() {
        let res = await this.getAction(this.url.list);
        if (!res.IsSuccess) {
          this.$toast({ position: "bottom", message: res.Msg });
        } else {
          this.historyData = res.Data;
        }
      },
      async clearHistory() {
        let res = await this.deleteAction(this.url.delete);
        this.historyData = res.Data;
        if (!res.IsSuccess) {
          this.$toast({ position: "bottom", message: res.Msg });
        }
        else {
          this.$bus.$emit('updateSearchKeyword', true)
        }
      },
      //补全
      onCompletion(val) {
        if (this.completioning) return;
        this.completioning = true;
        this.getAction(this.url.completion, { keyWord: val }).then(res => {
          if (!res.IsSuccess) {
            this.$toast({ position: "bottom", message: res.Msg });
          } else {
            this.completionData = res.Data;
          }
          this.completioning = false;
        });
      },
      _marginPhoneHeader(style) {
        try {
          return window.api.safeArea.top;
        } catch (error) {}
        return 35;
      }
    }
  };
</script>
<style lang="less">
  .search-page {
    height: 100vh;
    overflow: hidden;
    z-index: 3001;
    background-color: #fff;

    .search-line {
      width: 100vw;
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      color: #222222;

      .search-left {
        box-sizing: border-box;
        padding-left: 0.2rem;
        padding-right: 0.2rem;

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
          &:nth-child(2) {
            margin-left: 0.2rem;
          }
        }
      }

      .search-centent {
        width: 100%;
        border: none;
        height: 0.7rem;
        position: relative;
        box-sizing: border-box;
        background: rgba(246, 246, 246, 1);
        border-radius: 0.08rem;

        display: flex;
        align-items: center;

        padding-left: 0.2rem;

        input {
          color: rgba(182, 182, 182, 1);
          font-size: 0.24rem;
          font-weight: 400;
          text-align: left;
          padding-left: 0;
          padding-right: 0.1rem;
        }

        img {
          width: 0.23rem;
          margin-right: 0.14rem;
        }
      }

      >.search-text {
        width: 1rem;
        font-size: 0.28rem;
        padding: 0 0.2rem;
      }
    }

    .search-myline {
      @h: 52px;
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-left: 20px;
      color: #ffffff;

      .myline-left,
      .myline-right {
        width: ~"calc(50% - 15px)";
        background: linear-gradient(132deg,
            rgba(93, 149, 255, 1) 0%,
            rgba(70, 90, 251, 1) 40%,
            rgba(116, 75, 253, 1) 100%);
        border-radius: 4px;
        height: @h;
        margin-right: 5px;
        text-align: left;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        img {
          margin-top: 2px;
          height: 35px;
          float: left;
          margin-right: 5px;
        }
      }

      .text {
        margin-left: 3px;

        .txt1 {
          font-size: 14px;
        }

        .txt2 {
          font-size: 10px;
        }
      }

      .right {
        width: 20px;
        text-align: center;

        .van-icon {
          font-size: 18px;
        }

        margin-left: 5px;
      }

      .myline-right {
        background: linear-gradient(124deg,
            rgba(255, 181, 114, 1) 0%,
            rgba(255, 138, 63, 1) 49%,
            rgba(255, 124, 64, 1) 100%);
        margin-right: 0px;
        margin-left: 5px;
      }
    }

    .search-history {
      margin-top: 20px;
      padding: 0 10px;

      .history-title {
        font-size: 16px;
        font-weight: 700;
        color: #222222;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      }
    }

    .history-content,
    .tip-content {
      margin-top: 10px;

      li {
        list-style: none;
        text-align: left;
        padding: 13px 10px;
        font-size: 12px;
        cursor: pointer;
        border-bottom: 1px #f5f5f5 solid;
      }
    }
  }
</style>